import { text } from '@storybook/addon-knobs';
import { storiesOf } from '@storybook/react';
import * as React from 'react';
import { ToolTipDataComponent } from './tooltipdata';

storiesOf('Tool Tip data Bar', module).add('default', () => {
  let averageReturn = 4000;
  let averageReturnPercent = 4;
  let gainPercent = 4;
  let lossPercent = 0;

  return (
    <ToolTipDataComponent
      averageReturn={averageReturn}
      averageReturnPercent={averageReturnPercent}
      gainPercent={gainPercent}
      lossPercent={lossPercent}
    />
  );
});
